import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/node';

import {GetSpacesResponse} from '../types';

const getSpacesResponseMock: GetSpacesResponse = [
  {
    spaceId: 'f6f0b638-3af5-4938-a4f5-a5a4b2f22df3',
    isActive: true,
    name: 'Space 1',
    assignWarehouses: ['855bd140-6054-4d4b-beeb-2adbf5ee89b4'],
  },
  {
    spaceId: '05bd75b7-6a8b-4e39-b30f-55571795b3f9',
    isActive: false,
    name: 'Space 2',
    assignWarehouses: ['855bd140-6054-4d4b-beeb-2adbf5ee89b4'],
  },
  {
    spaceId: '9f8e35b3-24e2-4bd6-93d3-9d227c2c6e0f',
    isActive: true,
    name: 'Space 3',
    assignWarehouses: [],
  },
  {
    spaceId: '3fbd6c7d-92f1-4cd0-a1bd-6f5f3f0f2c11',
    isActive: false,
    name: 'Space 4',
    assignWarehouses: [],
  },
];

const getSpacesResponseInterceptor = (server: SetupServerApi) =>
  server.use(http.get('*/warehouse/v1/space', () => HttpResponse.json(getSpacesResponseMock)));

export const metadaWarehouseSpaceApiMock = {
  getSpacesResponseMock,
  getSpacesResponseInterceptor,
};
